<template>
  <div class="flex items-center gap-1 ml-5 text-gray-800">
    <div class="mr-1">
      <span class="text-md not-sr-only">A</span>
      <span class="text-3xl not-sr-only">A</span>
    </div>
    <button
      @click.prevent="decrease"
      class="w-5 h-5 bg-gray-200 hover:bg-gray-300 flex justify-center items-center rounded"
      title="Decrease font size"
    >
      -
    </button>
    <button
      @click.prevent="increase"
      class="w-5 h-5 bg-gray-200 hover:bg-gray-300 flex justify-center items-center rounded"
      title="Increase font size"
    >
      +
    </button>
  </div>
</template>

<script>
export default {
  data() {
    return {
      fontSize: 16,
      increment: 2,
      lowerBound: 16,
      upperBound: 32,
    };
  },
  created() {
    this.load();
  },
  methods: {
    load() {
      let size = localStorage.getItem('basefontsize');
      size = size ?? this.lowerBound;
      this.fontSize = this.limit(size);
      this.set();
    },
    set() {
      localStorage.setItem('basefontsize', this.fontSize);
      document.documentElement.style.setProperty('font-size', `${this.fontSize}px`);
    },
    decrease() {
      this.fontSize = this.limit(this.fontSize - this.increment);
      this.set();
    },
    increase() {
      this.fontSize = this.limit(this.fontSize + this.increment);
      this.set();
    },
    limit(val) {
      return Math.min(this.upperBound, Math.max(this.lowerBound, val));
    },
  },
};
</script>
